export default __webpack_public_path__ + "static/media/list-tree.09db9c69.svg";